<template>
  <div class="topic-card" :style="{ backgroundImage: `url(${image})` }">
    <div>
      <p class="topic-index">Topic {{ index + 1 }}</p>
      <h3 class="topic-title">{{ title }}</h3>
    </div>
    <p class="topic-description">{{ description }}</p>
  </div>
</template>

<script>
export default {
  name: 'TopicCard',
  props: {
    index: {
      type: Number,
      required: true
    },
    title: {
      type: String,
      required: true
    },
    image: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    }
  }
};
</script>

<style scoped>
.topic-card {
  background-size: cover;
  background-position: center;
  padding: 60px 45px;
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}
.topic-index {
  font-family: Red Hat Display;
  font-weight: 700;
  font-size: 18px;
  line-height: 100%;
  letter-spacing: -1%;
  color: #2be07d;
}
.topic-title {
  font-family: Pretendard;
  font-weight: 600;
  font-size: 30px;
  line-height: 100%;
  letter-spacing: -1%;
  color: #ffffff;
}
.topic-description {
  font-family: Pretendard;
  font-weight: 400;
  font-size: 20px;
  line-height: 140%;
  letter-spacing: -1%;
  color: #ffffff;
}

@media (min-width: 769px) and (max-width: 1199px) {
  .topic-index {
    font-size: calc(12px + (6 * ((100vw - 768px) / (1200 - 768))));
  }
  .topic-title {
    font-size: calc(20px + (10 * ((100vw - 768px) / (1200 - 768))));
  }
  .topic-description {
    font-size: calc(14px + (6 * ((100vw - 768px) / (1200 - 768))));
  }

  .topic-card {
    justify-content: end;
  }
}

@media (max-width: 768px) {
  .topic-index {
    font-size: calc(14px + (13 * ((100vw - 450px) / (768 - 450))));
  }

  .topic-title {
    font-size: calc(23px + (22 * ((100vw - 450px) / (768 - 450))));
  }
  .topic-description {
    font-size: calc(15px + (15 * ((100vw - 450px) / (768 - 450))));
  }
  .topic-card {
    justify-content: end;
  }
}
</style>
